import { Button, makeStyles, TextField } from '@material-ui/core';
import { useState } from 'react';
import { useNavigate } from 'react-router';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
  },
}));

function useForm(e) {
  const [entries, setEntries] = useState([]);
  function handleChange(e) {
    let { name, value } = e.target;
    if (value.includes('{') && value.includes('}')) {
      value = JSON.parse(value);
    }
    setEntries({ ...entries, [name]: value });
  }

  return {
    handleChange,
    entries,
  };
}

export default function CreateAdmin() {
  const classes = useStyles();
  const { handleChange, entries } = useForm();
  const navigate = useNavigate();

  const handleCreate = async () => {
    try {
      let response = await fetch(
        'https://api.edicionesmilenio.com/api/admins',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(entries),
        }
      );
      if (response.status === 201) {
        navigate('/admin/admins');
      } else {
        let json = await response.json();
        console.error(json.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás crear un nuevo
        administrador para la plataforma, los administradores tienen el control
        total de la misma.
      </p>
      <div
        style={{
          width: '100%',
          paddingLeft: '20px',
          paddingRight: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <TextField
          className={classes.input}
          label="Usuario"
          variant="outlined"
          name="username"
          onChange={handleChange}
          value={entries?.username}
        />
        <TextField
          className={classes.input}
          label="Contraseña"
          variant="outlined"
          name="password"
          onChange={handleChange}
          value={entries?.password}
          type={'password'}
        />
        <Button
          onClick={handleCreate}
          className={classes.input}
          variant="contained"
          color="primary"
          disabled={!entries?.username || !entries?.password}
        >
          Crear
        </Button>
      </div>
    </div>
  );
}
